.link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  padding: 0 16px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: var(--shadow-button);
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
}

.link:active {
  box-shadow: none;
  transform: translate(3px, 3px);
}

.plus {
  width: 16px;
  height: 16px;
  background-color: currentColor;
  -webkit-mask: url('./plus.svg') no-repeat center / contain;
  mask: url('./plus.svg') no-repeat center / contain;
}
